import { Component, Input, OnInit } from '@angular/core';
import { CalendarInt } from '@app/interfaces/calendar.interface';
import { KioskPropertiesGA4Int } from '@app/interfaces/ga4.interface';
import { CalendarService } from '@app/services/calendar.service';
import { Ga4Service } from '@app/services/ga4.service';
import { UrlService } from '@app/services/url.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment, { Moment } from 'moment';
/**
 * Componente de calendario interactivo.
 * 
 * Permite a los usuarios seleccionar una fecha y muestra el calendario del mes actual.
 * Envía eventos a GA4 cuando el modal se abre.
 */
@Component({
    selector: 'am-calendar',
    templateUrl: './am-calendar.component.html',
    styleUrls: ['./am-calendar.component.scss'],
    standalone: false
})
export class AmCalendarComponent implements OnInit {

  /** Día seleccionado por el usuario */
  @Input() daySelected: any;

  /** Día actual */
  currentDay: Moment;
  
  /** Nombre del mes actual */
  currentMonthName: string;
  
  /** Mapa de calendario generado */
  calendarMap: CalendarInt;
  
  /** Datos de los calendarios generados */
  calendars: any;
  
  /** Mes seleccionado */
  monthSelected: any;

  constructor(
    public modal: NgbActiveModal,
    private _calendarService: CalendarService,
    private _urlService: UrlService,
    private _ga4Service: Ga4Service
  ) {
  }

  ngOnInit() {
    this.currentDay = moment();

    this.calendarMap = this._calendarService.createCalendar(this.currentDay, this.daySelected);

    const firstDay = this._calendarService.getFirstDay(this.currentDay);
    this.calendars = this._calendarService.createCalendars(firstDay, this.daySelected);

    this.monthSelected = this._calendarService.navToMonth(this.daySelected ?? this.currentDay)();

    const userPropertiesModal: KioskPropertiesGA4Int = {
      page_location: this._urlService.currentUrl,
      page_referrer: this._urlService.beforeUrl,
      screen_resolution: '1280x1024',
      sub_funnel_name: 'SR_calendar_select_day'
    };

    this._ga4Service.sendKioskPropertiesEvent(userPropertiesModal);
  }
  /**
   * Captura la fecha seleccionada por el usuario y cierra el modal.
   * 
   * @param day Día seleccionado
   */
  catchDateSelected(day) {
    this.daySelected = day;

    this.modal.close(this.daySelected);
  }

  onClose() {
    this.modal.close();
  }
}
